/* tslint:disable */

declare var Object: any;
export interface TempLeaseRenewalInterface {
  "lease_id": number;
  "start_date"?: Date;
  "end_date"?: Date;
  "rent_amount"?: number;
  "frequency"?: string;
  "chart_of_account_id"?: number;
  "tenant_deposits"?: Array<any>;
  "tenant_fees"?: Array<any>;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class TempLeaseRenewal implements TempLeaseRenewalInterface {
  "lease_id": number;
  "start_date": Date;
  "end_date": Date;
  "rent_amount": number;
  "frequency": string;
  "chart_of_account_id": number;
  "tenant_deposits": Array<any>;
  "tenant_fees": Array<any>;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: TempLeaseRenewalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TempLeaseRenewal`.
   */
  public static getModelName() {
    return "TempLeaseRenewal";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TempLeaseRenewal for dynamic purposes.
  **/
  public static factory(data: TempLeaseRenewalInterface): TempLeaseRenewal{
    return new TempLeaseRenewal(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TempLeaseRenewal',
      plural: 'TempLeaseRenewals',
      path: 'TempLeaseRenewals',
      idName: 'id',
      properties: {
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "start_date": {
          name: 'start_date',
          type: 'Date'
        },
        "end_date": {
          name: 'end_date',
          type: 'Date'
        },
        "rent_amount": {
          name: 'rent_amount',
          type: 'number'
        },
        "frequency": {
          name: 'frequency',
          type: 'string'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "tenant_deposits": {
          name: 'tenant_deposits',
          type: 'Array&lt;any&gt;'
        },
        "tenant_fees": {
          name: 'tenant_fees',
          type: 'Array&lt;any&gt;'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
